export default __webpack_public_path__ + "static/media/hero.99bd58ff.png";